export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('BON_RECEPTION_ORDER_LINKED_TO_DELIVERY_NOTE') === 0) {
      const codes = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'listeSuiviAchats.messages.errors.commandeDejaReceptionner',
        parametres: { code: codes },
      });
    }
  });
}
